"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ContentLoader_1 = __importDefault(require("../../framework/stencil/ContentLoader"));
const Rect_1 = __importDefault(require("../../framework/stencil/Rect"));
const styling_1 = require("../../framework/stencil/styling");
const styles_1 = __importDefault(require("./styles"));
const ContentLoading = () => {
    const styles = (0, styling_1.useStyling)(styles_1.default);
    return (react_1.default.createElement(ContentLoader_1.default, { backgroundColor: styles.dayOneTileLoading.backgroundColor, foregroundColor: styles.dayOneTileLoading.foregroundColor, width: "50%", height: 61, speed: 2, testID: "loading-state" },
        react_1.default.createElement(Rect_1.default, { x: "0", y: "0", rx: "1", ry: "1", height: "16", width: "99%" }),
        react_1.default.createElement(Rect_1.default, { x: "0", y: "29", rx: "1", ry: "1", height: "12", width: "85%" }),
        react_1.default.createElement(Rect_1.default, { x: "0", y: "49", rx: "1", ry: "1", height: "12", width: "69%" })));
};
exports.default = ContentLoading;
//# sourceMappingURL=ContentLoading.js.map